module.exports = __webpack_public_path__ + "static/img/ic_star_small_off.a1e01b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/ic_star_small_off.png
// module id = QKrP
// module chunks = 10